import { useQuery } from '@tanstack/react-query';

import { getCountry } from '@utilities/country';

export const useCountry = () => {
  const { data: country } = useQuery({
    queryKey: ['country'],
    queryFn: ({ signal }) => getCountry(signal),
  });

  return country;
};
